import { render, staticRenderFns } from "./Bases.vue?vue&type=template&id=27ba24bf&scoped=true&"
import script from "./Bases.vue?vue&type=script&lang=js&"
export * from "./Bases.vue?vue&type=script&lang=js&"
import style0 from "./Bases.vue?vue&type=style&index=0&id=27ba24bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ba24bf",
  null
  
)

component.options.__file = "Bases.vue"
export default component.exports